//本目录只放置全站关于配置管理的js
export default {
    install(Vue, options) {
        Vue.prototype.$setStorage = function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        },
            Vue.prototype.$getStorage = function (key) {
                return JSON.parse(localStorage.getItem(key));
            },
            Vue.prototype.$removeStorage = function (key) {
                localStorage.removeItem(key);
            },
            Vue.prototype.$delectObj = function (obj, array) {
                if (array) {
                    array.forEach(element => {
                        obj[element] = ""
                    });
                } else {
                    for (let key in obj) {
                        obj[key] = ''
                    }
                }
                return obj;
            },
            Vue.prototype.$setDefaultObj = function (obj, array, value) {
                if (array.length > 0) {
                    if (value == 0) {
                        array.forEach(element => {
                            if (obj[element] == null ||
                                obj[element] == "" || obj[element] < 0 || obj[element] == 'e') {
                                obj[element] = value
                            }
                        });
                    } else {
                        array.forEach(element => {
                            if (obj[element] == null ||
                                obj[element] == "" || obj[element] < 0) {
                                obj[element] = value
                            }
                        });
                    }

                } else {
                    if (value == 0) {
                        for (let key in obj) {
                            if (obj[key] == null ||
                                obj[key] == "" || obj[key] < 0) {
                                obj[key] = value
                            }

                        }
                    } else {
                        for (let key in obj) {
                            if (obj[key] == null ||
                                obj[key] == "" || obj[key] < 0 || obj[key] == 'e') {
                                obj[key] = value
                            }

                        }
                    }
                }
                return obj;
            },
            Vue.prototype.$buttonAuthority = function (array, str) {
                let a = false
                if (array.length > 0) {
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        if (element.resource_path == str) {
                            a = true
                            break;
                        }

                    }
                    return a;
                } else {
                    return false

                }
            }
    }
} 